export default function createTimeStamp() {
  return Math.floor(Date.now() / 1000);
}
